import React from 'react';
import { BrowserRouter, Routes, Route, useNavigate } from 'react-router-dom';
import DocumentAgent from './DocumentAgent';
import TranslateAgent from './TranslateAgent';
import DataAgent from './DataAgent';
import EmailAgent from './EmailAgent';
import ChatbotAgent from './ChatbotAgent';
import ReportAgent from './ReportAgent';
import SpecAgent from './SpecAgent';
import MigrateAgent from './MigrateAgent';
import ErdAgent from './ErdAgent';
import ProposalAgent from './ProposalAgent';
import MeetingAgent from './MeetingAgent';
import ImageAgent from './ImageAgent';
import PptAgent from './PptAgent';
import KnowledgeAgent from './KnowledgeAgent';
import RpaAgent from './RpaAgent';
import DashboardAgent from './DashboardAgent';
import CrawlAgent from './CrawlAgent';
import SapChatAgent from './SapChatAgent';

const AGENTS = [
  {
    id: 'sap-chat',
    name: 'SAP 테이블 검색',
    tech: 'SAP DD / Vector Search / RAG',
    desc: 'SAP Data Dictionary를 학습한 AI가 업무에 필요한 테이블, 컬럼, JOIN 관계를 찾아줍니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="6" width="16" height="14" rx="3" fill="#e8f0fe" stroke="#0054a6" strokeWidth="2"/>
        <rect x="28" y="6" width="16" height="14" rx="3" fill="#e8f0fe" stroke="#0054a6" strokeWidth="2"/>
        <rect x="16" y="28" width="16" height="14" rx="3" fill="#e8f0fe" stroke="#0054a6" strokeWidth="2"/>
        <path d="M20 13h8M12 20v8M36 20v8" stroke="#0054a6" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    color: '#0054a6',
    bgColor: '#e8f0fe',
    path: '/agent/sap-chat',
    ready: true,
  },
  {
    id: 'report',
    name: '보고서 작성 에이전트',
    tech: 'SAP HANA / ABAP FS·TS / OData',
    desc: 'SAP HANA DB 테이블을 분석하여 스펙 정의서를 자동 생성합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="6" y="6" width="30" height="36" rx="3" fill="#e8f8e8" stroke="#2e7d32" strokeWidth="2"/>
        <path d="M12 16h18M12 22h18M12 28h12" stroke="#2e7d32" strokeWidth="2" strokeLinecap="round"/>
        <rect x="28" y="28" width="14" height="14" rx="3" fill="#2e7d32"/>
        <path d="M32 35h6M35 32v6" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    color: '#2e7d32',
    bgColor: '#e8f8e8',
    path: '/agent/report',
    ready: true,
  },
  {
    id: 'spec',
    name: '스펙정의서',
    tech: 'FS·TS / AI 보정 / Word·PDF',
    desc: '저장된 FS/TS 스펙을 조회하고 AI로 보정, Word/Excel/PDF 다운로드합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="6" y="4" width="28" height="36" rx="3" fill="#e3f2fd" stroke="#1565c0" strokeWidth="2"/>
        <path d="M12 14h16M12 20h16M12 26h10" stroke="#1565c0" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="36" cy="36" r="10" fill="#1565c0"/>
        <path d="M33 36l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: '#1565c0',
    bgColor: '#e3f2fd',
    path: '/agent/spec',
    ready: true,
  },
  {
    id: 'erd',
    name: 'AI ERD 설계',
    tech: 'Canvas / DDL / Reverse Engineering',
    desc: '자연어로 ERD 자동 설계, DB 역공학, DDL 생성, AI 정규화 분석을 지원합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="6" width="16" height="14" rx="3" fill="#f3e8fd" stroke="#7b1fa2" strokeWidth="2"/>
        <rect x="28" y="6" width="16" height="14" rx="3" fill="#f3e8fd" stroke="#7b1fa2" strokeWidth="2"/>
        <rect x="16" y="28" width="16" height="14" rx="3" fill="#f3e8fd" stroke="#7b1fa2" strokeWidth="2"/>
        <path d="M20 13h8M12 20v8M36 20v8" stroke="#7b1fa2" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    color: '#7b1fa2',
    bgColor: '#f3e8fd',
    path: '/agent/erd',
    ready: true,
  },
  {
    id: 'migrate',
    name: 'DB 마이그레이션',
    tech: 'PG·MySQL·MSSQL·HANA / AI 변환',
    desc: 'AI 기반으로 DB간 테이블, 뷰, 프로시저, 데이터를 자동 마이그레이션합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="2" y="12" width="16" height="24" rx="3" fill="#e8eaf6" stroke="#1a237e" strokeWidth="2"/>
        <rect x="30" y="12" width="16" height="24" rx="3" fill="#e8eaf6" stroke="#1a237e" strokeWidth="2"/>
        <path d="M18 20h12M18 24h12M18 28h12" stroke="#3949ab" strokeWidth="2" strokeLinecap="round"/>
        <path d="M24 18l3-3-3-3" stroke="#3949ab" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M24 30l3 3-3 3" stroke="#3949ab" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: '#1a237e',
    bgColor: '#e8eaf6',
    path: '/agent/migrate',
    ready: true,
  },
  {
    id: 'document',
    name: '문서 분석 에이전트',
    tech: 'OCR / Embedding / Claude Vision',
    desc: '문서를 업로드하면 AI가 내용을 분석하고, 질문에 답변합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="8" y="4" width="26" height="34" rx="3" fill="#e8f4fd" stroke="#1a73e8" strokeWidth="2"/>
        <path d="M14 14h14M14 20h14M14 26h8" stroke="#1a73e8" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="34" cy="34" r="10" fill="#1a73e8"/>
        <path d="M31 34l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: '#1a73e8',
    bgColor: '#e8f4fd',
    path: '/agent/document',
    ready: true,
  },
  {
    id: 'knowledge',
    name: '사내 지식 검색',
    tech: 'RAG / 내부문서 / Q&A',
    desc: '회사 문서를 등록하면 AI가 내용을 학습하고, 질문에 답변합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="22" cy="22" r="14" fill="#e3f2fd" stroke="#0d47a1" strokeWidth="2"/>
        <path d="M32 32l8 8" stroke="#0d47a1" strokeWidth="3" strokeLinecap="round"/>
        <path d="M16 18h12M16 24h8" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    color: '#0d47a1',
    bgColor: '#e3f2fd',
    path: '/agent/knowledge',
    ready: true,
  },
  {
    id: 'data',
    name: '데이터 분석 에이전트',
    tech: 'CSV·Excel / Chart / Statistics',
    desc: 'CSV, Excel 데이터를 분석하여 인사이트와 차트를 제공합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="6" y="30" width="8" height="12" rx="2" fill="#0288d1"/>
        <rect x="17" y="22" width="8" height="20" rx="2" fill="#0288d1"/>
        <rect x="28" y="14" width="8" height="28" rx="2" fill="#0288d1"/>
        <path d="M10 28L21 18l11 6 8-12" stroke="#01579b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <circle cx="40" cy="12" r="3" fill="#e1f5fe" stroke="#0288d1" strokeWidth="2"/>
      </svg>
    ),
    color: '#0288d1',
    bgColor: '#e1f5fe',
    path: '/agent/data',
    ready: true,
  },
  {
    id: 'dashboard',
    name: '대시보드 에이전트',
    tech: 'CSV·JSON / AI 분석 / SVG 차트',
    desc: '데이터를 입력하면 AI가 자동으로 시각화 대시보드를 생성합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="4" width="40" height="40" rx="6" fill="#e3f2fd" stroke="#1565c0" strokeWidth="2"/>
        <rect x="8" y="22" width="8" height="16" rx="2" fill="#1565c0"/>
        <rect x="20" y="14" width="8" height="24" rx="2" fill="#1976d2"/>
        <rect x="32" y="8" width="8" height="30" rx="2" fill="#1e88e5"/>
        <path d="M12 20L24 12l12 6" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: '#1565c0',
    bgColor: '#e3f2fd',
    path: '/agent/dashboard',
    ready: true,
  },
  {
    id: 'chat',
    name: '업무 챗봇',
    tech: 'RAG / Web Crawling / TTS',
    desc: '증권의 발행 및 공시 등에 관한 규정을 학습한 AI 상담 챗봇입니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="8" width="28" height="20" rx="4" fill="#fef3e2" stroke="#e67700" strokeWidth="2"/>
        <rect x="16" y="20" width="28" height="20" rx="4" fill="#fef3e2" stroke="#e67700" strokeWidth="2"/>
        <circle cx="24" cy="30" r="2" fill="#e67700"/>
        <circle cx="30" cy="30" r="2" fill="#e67700"/>
        <circle cx="36" cy="30" r="2" fill="#e67700"/>
      </svg>
    ),
    color: '#e67700',
    bgColor: '#fef3e2',
    path: '/agent/chat',
    ready: true,
  },
  {
    id: 'meeting',
    name: '회의 에이전트(화상, TTS)',
    tech: 'TTS / 화상회의 / AI 작성 / Word·PDF',
    desc: '화상회의, 음성인식, TTS 읽기를 지원하는 AI 회의록 작성 에이전트입니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="6" y="4" width="28" height="36" rx="3" fill="#e0f2f1" stroke="#00695c" strokeWidth="2"/>
        <path d="M12 14h16M12 20h16M12 26h10" stroke="#00695c" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="36" cy="36" r="10" fill="#00695c"/>
        <path d="M33 36h6M36 33v6" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    color: '#00695c',
    bgColor: '#e0f2f1',
    path: '/agent/meeting',
    ready: true,
  },
  {
    id: 'email',
    name: '이메일 작성 에이전트',
    tech: 'SMTP / Template / Rewrite',
    desc: '상황에 맞는 비즈니스 이메일을 자동으로 작성합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="10" width="40" height="28" rx="4" fill="#ffebee" stroke="#c62828" strokeWidth="2"/>
        <path d="M4 14l20 14 20-14" stroke="#c62828" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: '#c62828',
    bgColor: '#ffebee',
    path: '/agent/email',
    ready: true,
  },
  {
    id: 'proposal',
    name: 'AI 제안서 생성',
    tech: 'Pre-Sales / RFP / 견적 자동화',
    desc: '프로젝트 정보를 입력하면 AI가 전문 제안서를 자동으로 작성합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="8" y="4" width="26" height="34" rx="3" fill="#e3f2fd" stroke="#0d47a1" strokeWidth="2"/>
        <path d="M14 14h14M14 20h14M14 26h8" stroke="#0d47a1" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="36" cy="36" r="10" fill="#0d47a1"/>
        <path d="M33 36h6M36 33v6" stroke="white" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    color: '#0d47a1',
    bgColor: '#e3f2fd',
    path: '/agent/proposal',
    ready: true,
  },
  {
    id: 'ppt',
    name: 'PPT 생성 에이전트',
    tech: 'AI 구성 / 테마 / PPTX 다운로드',
    desc: '텍스트나 파일을 업로드하면 AI가 전문적인 PPT를 자동 생성합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="6" y="4" width="30" height="36" rx="3" fill="#fce4ec" stroke="#e91e63" strokeWidth="2"/>
        <rect x="12" y="12" width="18" height="4" rx="1" fill="#e91e63" opacity="0.7"/>
        <rect x="12" y="20" width="14" height="3" rx="1" fill="#e91e63" opacity="0.4"/>
        <rect x="12" y="26" width="16" height="3" rx="1" fill="#e91e63" opacity="0.4"/>
        <rect x="12" y="32" width="10" height="3" rx="1" fill="#e91e63" opacity="0.4"/>
        <circle cx="36" cy="36" r="10" fill="#e91e63"/>
        <path d="M33 36l2 2 4-4" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    color: '#e91e63',
    bgColor: '#fce4ec',
    path: '/agent/ppt',
    ready: true,
  },
  {
    id: 'image',
    name: '이미지 생성 에이전트',
    tech: 'Nova Canvas / Titan Image / AI 생성',
    desc: 'AI가 텍스트 설명을 기반으로 고품질 이미지를 생성합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="4" width="40" height="40" rx="6" fill="#f3e8fd" stroke="#7c4dff" strokeWidth="2"/>
        <circle cx="16" cy="18" r="4" fill="#7c4dff"/>
        <path d="M4 32l10-10 8 8 6-6 16 16H4V32z" fill="#7c4dff" opacity="0.5"/>
        <path d="M28 26l16 16H12l16-16z" fill="#7c4dff" opacity="0.7"/>
      </svg>
    ),
    color: '#7c4dff',
    bgColor: '#f3e8fd',
    path: '/agent/image',
    ready: true,
  },
  {
    id: 'translate',
    name: '번역 에이전트',
    tech: 'NMT / 15개 언어 / 5가지 스타일',
    desc: '문서나 텍스트를 다국어로 자연스럽게 번역합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="18" cy="24" r="14" fill="#f3e8fd" stroke="#7b1fa2" strokeWidth="2"/>
        <circle cx="30" cy="24" r="14" fill="none" stroke="#7b1fa2" strokeWidth="2"/>
        <text x="12" y="28" fontSize="14" fill="#7b1fa2" fontWeight="bold">A</text>
        <text x="30" y="28" fontSize="12" fill="#7b1fa2" fontWeight="bold">가</text>
      </svg>
    ),
    color: '#7b1fa2',
    bgColor: '#f3e8fd',
    path: '/agent/translate',
    ready: true,
  },
  {
    id: 'crawl',
    name: '크롤링 에이전트',
    tech: 'Web Crawling / AI 분석 / 링크수집',
    desc: '웹 사이트를 크롤링하여 AI가 원하는 정보를 자동으로 정리합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="18" fill="#fff3e0" stroke="#e65100" strokeWidth="2"/>
        <circle cx="24" cy="24" r="6" fill="#e65100"/>
        <path d="M24 6v6M24 36v6M6 24h6M36 24h6M11 11l4 4M33 33l4 4M11 37l4-4M33 15l4-4" stroke="#e65100" strokeWidth="2" strokeLinecap="round"/>
      </svg>
    ),
    color: '#e65100',
    bgColor: '#fff3e0',
    path: '/agent/crawl',
    ready: true,
  },
  {
    id: 'rpa',
    name: '반복 업무 자동화',
    tech: 'RPA / AI 스크립트 / 스케줄링',
    desc: '반복 작업을 AI가 자동화 스크립트로 만들어 실행합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <circle cx="24" cy="24" r="16" fill="#fff3e0" stroke="#e65100" strokeWidth="2"/>
        <path d="M24 12v6M24 30v6M14.34 14.34l4.24 4.24M29.42 29.42l4.24 4.24M12 24h6M30 24h6" stroke="#e65100" strokeWidth="2.5" strokeLinecap="round"/>
      </svg>
    ),
    color: '#e65100',
    bgColor: '#fff3e0',
    path: '/agent/rpa',
    ready: true,
  },
  {
    id: 'n8n',
    name: 'n8n 워크플로우 자동화',
    tech: 'No-Code / S3·Email 자동화',
    desc: '노코드로 업무 자동화 워크플로우를 구축하고 관리합니다.',
    icon: (
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
        <rect x="4" y="16" width="14" height="14" rx="3" fill="#ff6d5a" stroke="#d84315" strokeWidth="2"/>
        <rect x="30" y="8" width="14" height="14" rx="3" fill="#ff6d5a" stroke="#d84315" strokeWidth="2"/>
        <rect x="30" y="26" width="14" height="14" rx="3" fill="#ff6d5a" stroke="#d84315" strokeWidth="2"/>
        <path d="M18 20h12M18 26h12" stroke="#d84315" strokeWidth="2" strokeLinecap="round"/>
        <circle cx="18" cy="20" r="2" fill="#d84315"/>
        <circle cx="18" cy="26" r="2" fill="#d84315"/>
        <circle cx="30" cy="15" r="2" fill="#d84315"/>
        <circle cx="30" cy="33" r="2" fill="#d84315"/>
      </svg>
    ),
    color: '#d84315',
    bgColor: '#fbe9e7',
    path: 'http://43.202.161.149:5678',
    ready: true,
    external: true,
  },
];

function Home() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa' }}>
      {/* 헤더 */}
      <div style={{
        background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)',
        padding: '48px 20px 56px', textAlign: 'center'
      }}>
        <h1 style={{ color: 'white', fontSize: 32, margin: 0, fontWeight: 700, letterSpacing: -0.5 }}>
          CLSOFTLAB AI SERVICE
        </h1>
        <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 16, marginTop: 10 }}>
          업무에 필요한 AI 에이전트를 선택하세요
        </p>
      </div>

      {/* 에이전트 카드 그리드 */}
      <div style={{
        maxWidth: 1000, margin: '-32px auto 0', padding: '0 20px 60px',
        display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20
      }}>
        {AGENTS.map(agent => (
          <div key={agent.id}
            onClick={() => {
              if (!agent.ready) return;
              if (agent.external) { window.open(agent.path, '_blank'); return; }
              navigate(agent.path);
            }}
            style={{
              background: 'white', borderRadius: 12, padding: 24,
              border: '1px solid #e0e0e0',
              cursor: agent.ready ? 'pointer' : 'default',
              transition: 'all 0.2s ease',
              opacity: agent.ready ? 1 : 0.6,
              position: 'relative',
              boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
            }}
            onMouseEnter={e => {
              if (agent.ready) {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.12)';
                e.currentTarget.style.borderColor = agent.color;
              }
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.06)';
              e.currentTarget.style.borderColor = '#e0e0e0';
            }}
          >
            {!agent.ready && (
              <span style={{
                position: 'absolute', top: 12, right: 12,
                background: '#f1f3f4', color: '#999', fontSize: 11,
                padding: '2px 10px', borderRadius: 10, fontWeight: 'bold'
              }}>
                준비중
              </span>
            )}
            <div style={{
              width: 64, height: 64, borderRadius: 16,
              background: agent.bgColor,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              marginBottom: 16
            }}>
              {agent.icon}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
              <h3 style={{ margin: 0, fontSize: 17, color: '#1a1a2e' }}>{agent.name}</h3>
              {agent.tech && (
                <span style={{
                  fontSize: 10, padding: '2px 8px', borderRadius: 10,
                  background: agent.bgColor, color: agent.color,
                  fontWeight: 'bold', whiteSpace: 'nowrap',
                  border: '1px solid ' + agent.color + '33',
                }}>{agent.tech}</span>
              )}
            </div>
            <p style={{ margin: 0, fontSize: 14, color: '#666', lineHeight: 1.6 }}>
              {agent.desc}
            </p>
            {agent.ready && (
              <div style={{
                marginTop: 16, display: 'inline-flex', alignItems: 'center', gap: 6,
                color: agent.color, fontSize: 14, fontWeight: 'bold'
              }}>
                시작하기
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M6 4l4 4-4 4" stroke={agent.color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function ComingSoon() {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#f5f7fa', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 64, marginBottom: 16 }}>
          <svg width="80" height="80" viewBox="0 0 80 80" fill="none">
            <circle cx="40" cy="40" r="36" fill="#f1f3f4" stroke="#ccc" strokeWidth="2"/>
            <path d="M30 42h20M40 32v20" stroke="#999" strokeWidth="3" strokeLinecap="round"/>
          </svg>
        </div>
        <h2 style={{ color: '#333', marginBottom: 8 }}>준비 중입니다</h2>
        <p style={{ color: '#888', marginBottom: 24 }}>이 에이전트는 현재 개발 중입니다.</p>
        <button onClick={() => navigate('/')}
          style={{
            padding: '10px 24px', background: '#1a73e8', color: 'white',
            border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 15
          }}>
          돌아가기
        </button>
      </div>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/agent/document" element={<DocumentAgent />} />
        <Route path="/agent/chat" element={<ChatbotAgent />} />
        <Route path="/agent/report" element={<ReportAgent />} />
        <Route path="/agent/translate" element={<TranslateAgent />} />
        <Route path="/agent/data" element={<DataAgent />} />
        <Route path="/agent/email" element={<EmailAgent />} />
        <Route path="/agent/proposal" element={<ProposalAgent />} />
        <Route path="/agent/spec" element={<SpecAgent />} />
        <Route path="/agent/migrate" element={<MigrateAgent />} />
        <Route path="/agent/erd" element={<ErdAgent />} />
        <Route path="/agent/meeting" element={<MeetingAgent />} />
        <Route path="/agent/ppt" element={<PptAgent />} />
        <Route path="/agent/knowledge" element={<KnowledgeAgent />} />
        <Route path="/agent/rpa" element={<RpaAgent />} />
        <Route path="/agent/image" element={<ImageAgent />} />
        <Route path="/agent/dashboard" element={<DashboardAgent />} />
        <Route path="/agent/crawl" element={<CrawlAgent />} />
        <Route path="/agent/sap-chat" element={<SapChatAgent />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
